<template>
    <app-layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Profile">
        <template #header>
            <h2 class="text-1xl md:text-2xl font-semibold transition duration-500 ease-in-out text-white sm:text-gray-600 sm:dark:text-white col-span-1 md:col-span-2">
                Profile
            </h2>
        </template>
        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <div v-if="$page.props.jetstream.canUpdateProfileInformation">
                    <update-profile-information-form :user="$page.props.user" />
                    <jet-section-border />
                </div>
                <div v-if="$page.props.racingstars.canUpdateAddressInformation">
                    <update-address-information-form class="mt-10 sm:mt-0" :user="$page.props.user" />
                    <jet-section-border />
                </div>
                <div v-if="$page.props.jetstream.canUpdatePassword">
                    <update-password-form class="mt-10 sm:mt-0" />
                    <jet-section-border />
                </div>
                <div>
                    <achievement-badge-selection class="mt-10 sm:mt-0" />
                    <jet-section-border />
                </div>
                <!-- Disabled 2FA feature as it needs re-working -->
                <div v-if="$page.props.jetstream.canManageTwoFactorAuthentication">
                    <two-factor-authentication-form class="mt-10 sm:mt-0" />
                    <jet-section-border />
                </div>
                <div>
                    <ShowImpliedProbability class="mt-10 sm:mt-0"  :user="$page.props.user" />
                    <jet-section-border />
                </div>
                <logout-other-browser-sessions-form :sessions="sessions" class="mt-10 sm:mt-0" />
                <template v-if="$page.props.jetstream.hasAccountDeletionFeatures">
                    <jet-section-border />
                    <delete-user-form class="mt-10 sm:mt-0" />
                </template>
            </div>
        </div>
    </app-layout>
</template>
<script>
import AppLayout from '@/Layouts/Layout.vue'
import DeleteUserForm from '@/Pages/Profile/Partials/DeleteUserForm.vue'
import JetSectionBorder from '@/Jetstream/SectionBorder.vue'
import LogoutOtherBrowserSessionsForm from '@/Pages/Profile/Partials/LogoutOtherBrowserSessionsForm.vue'
import TwoFactorAuthenticationForm from '@/Pages/Profile/Partials/TwoFactorAuthenticationForm.vue'
import UpdatePasswordForm from '@/Pages/Profile/Partials/UpdatePasswordForm.vue'
import UpdateProfileInformationForm from '@/Pages/Profile/Partials/UpdateProfileInformationForm.vue'
import UpdateAddressInformationForm from '@/Pages/Profile/Partials/UpdateAddressInformationForm.vue'
import ShowImpliedProbability from '@/Pages/Profile/Partials/ShowImpliedProbability.vue'
import AchievementBadgeSelection from '@/Pages/Profile/Partials/AchievementBadgeSelection.vue'

export default {
    props: ['sessions'],
    components: {
    AppLayout,
    DeleteUserForm,
    JetSectionBorder,
    LogoutOtherBrowserSessionsForm,
    TwoFactorAuthenticationForm,
    UpdatePasswordForm,
    UpdateProfileInformationForm,
    UpdateAddressInformationForm,
    ShowImpliedProbability,
    AchievementBadgeSelection
},
}

</script>
